import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import AdminMenuObject from "shared/admin-menu"
import styles from "./navigation-mobile.module.css"

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface TAdminMenuDescription {
    name: string
    link: string
    submenu?: TAdminMenuDescription[]
    icon: string
}

const options = [
  'None',
  'Atria',
  'Callisto',
  'Dione',
  'Ganymede',
  'Hangouts Call',
  'Luna',
  'Oberon',
  'Phobos',
  'Pyxis',
  'Sedna',
  'Titania',
  'Triton',
  'Umbriel',
];

const ITEM_HEIGHT = 48;

export const NavigationMobile = () => {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

    const makeAdminUI = useCallback((description: TAdminMenuDescription[]) => {
        return description.map((el: TAdminMenuDescription) => {
            const isSelected = "/" + location.pathname.split('/').at(1) === el.link;
            return (
                <ListItemButton
                    key={el.link}
                    onClick={() => { navigate(el.link || '') }}
                    selected={isSelected}
                >
                    <ListItemIcon>
                        <img src={el.icon} alt={'NoImg'}/>
                    </ListItemIcon>
                    <ListItemText>{el.name}</ListItemText>
                </ListItemButton>
            )
        })
    }, [])

    const menuUi = makeAdminUI(AdminMenuObject())

    return (
        <div className={styles.App}>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                }}
            >
            {AdminMenuObject().map((option) => (
                <MenuItem key={option.name} selected={"/" + location.pathname.split('/').at(1) === option.link} onClick={() => {
                    navigate(option.link)
                    handleClose()
                }}>
                    {option.name}
                </MenuItem>
            ))}
            </Menu>
        </div>
    )
}